export default "__VITE_ASSET__44fd5295__"